import { useEffect, useState } from 'react';

const useWebSocket = (url) => {
  const [socket, setSocket] = useState(null);
  const [messages, setMessages] = useState([]);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    // Create WebSocket connection
    const ws = new WebSocket(url);

    // Handle connection open
    ws.onopen = () => {
      console.log('WebSocket connection established');
      setIsConnected(true);
    };

    // Handle incoming messages
    ws.onmessage = (event) => {
      console.log('Message from server:', event.data);
      setMessages((prev) => [...prev, event.data]);
    };

    // Handle connection close
    ws.onclose = () => {
      console.log('WebSocket connection closed');
      setIsConnected(false);
    };

    // Handle connection errors
    ws.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    // Save WebSocket instance and cleanup on unmount
    setSocket(ws);
    return () => {
      ws.close();
    };
  }, [url]);

  // Function to send a message
  const sendMessage = (message) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(message);
    } else {
      console.error('WebSocket is not connected.');
    }
  };

  return { messages, isConnected, sendMessage };
};

export default useWebSocket;
